"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCompanyFeatureActive = exports.getTaxRate = void 0;
const isCompanyFeatureActive = (company, feature) => {
  return company && company.companyFeatures && !!company.companyFeatures.find(f => f.name === feature && !!f.active);
};
exports.isCompanyFeatureActive = isCompanyFeatureActive;
const getTaxRate = (company = {}) => (company === null || company === void 0 ? void 0 : company.tax_rate) || 8.25;
exports.getTaxRate = getTaxRate;